/**
 * Maps current vs previous BI metric to BaseTag tone (aligned with BIDisplayValue `diff` / isPositive).
 * Use the same `value - comparisonValue` rules as the component: `null` baseline coerces like JS `-` (→ 0),
 * so a strong % gain vs a null/0 previous period is not misclassified as neutral.
 * Zero change (diff === 0) uses `warning` to mirror the former yellow “neutral” emphasis.
 */
export function getBiDisplayComparisonTone(value, comparisonValue) {
  if (value === undefined || value === null) {
    return 'neutral';
  }
  if (comparisonValue === undefined) {
    return 'neutral';
  }
  // Intentionally allow comparisonValue === null: matches `this.value - this.comparisonValue` (null → 0).
  const diff = value - comparisonValue;
  if (Number.isNaN(diff)) {
    return 'neutral';
  }
  if (diff > 0) return 'success';
  if (diff < 0) return 'destructive';
  return 'warning';
}
